/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_wc_speaking_time = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speaking time`)
};

const es_wc_speaking_time = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiempo de oratoria`)
};

const de_wc_speaking_time = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprechzeit`)
};

const nl_wc_speaking_time = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spreektijd`)
};

const fr_wc_speaking_time = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temps de parole`)
};

const it_wc_speaking_time = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempo di parlato`)
};

const pt_br2_wc_speaking_time = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempo de fala`)
};

const pt_wc_speaking_time = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempo de fala`)
};

const ja_wc_speaking_time = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`話す時間`)
};

const zh_wc_speaking_time = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`朗读时间`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wc_speaking_time = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wc_speaking_time(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("wc_speaking_time", locale)
	if (locale === "en") return en_wc_speaking_time(inputs)
	if (locale === "es") return es_wc_speaking_time(inputs)
	if (locale === "de") return de_wc_speaking_time(inputs)
	if (locale === "nl") return nl_wc_speaking_time(inputs)
	if (locale === "fr") return fr_wc_speaking_time(inputs)
	if (locale === "it") return it_wc_speaking_time(inputs)
	if (locale === "pt-BR") return pt_br2_wc_speaking_time(inputs)
	if (locale === "pt") return pt_wc_speaking_time(inputs)
	if (locale === "ja") return ja_wc_speaking_time(inputs)
	return zh_wc_speaking_time(inputs)
};